import Axios from "axios";
import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
import AppConfig from "../../../../../config/AppConfig";
class ChartSebaranPTVBerdasarkanKategori extends Component {
  constructor(props) {
    super(props);
    this.state = {
      label: [],
      politeknik_negeri: [],
      politeknik_swasta: [],
      // politeknik_kedinasan: [],
      akademi_negeri: [],
      akademi_swasta: [],
      // akademi_kedinasan: [],
      ak_negeri: [],
      ak_swasta: [],
      // ak_kedinasan: [],
      loading: false,
    };
  }

  options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            },
          },
        },
      ],
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
  };
  getData() {
    this.setState({
      loading: true,
    });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata) {
      session =
        "?tipe_lembaga=" +
        this.props.tipe_lembaga +
        "&id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    let i = 0;
    let labels = [];
    let politeknik_negeri = [];
    let politeknik_swasta = [];
    // let politeknik_kedinasan = [];
    let akademi_negeri = [];
    let akademi_swasta = [];
    // let akademi_kedinasan = [];
    let ak_negeri = [];
    let ak_swasta = [];
    // let ak_kedinasan = [];
    Axios.get(AppConfig.DetailDashboard + "sebaranptvbykategori" + session)
      .then((res) => {
        for (var key in res.data.result.data_vokasi) {
          labels[i] = key;
          politeknik_negeri[i] = res.data.result.data_vokasi[key].politeknik_negeri;
          politeknik_swasta[i] = res.data.result.data_vokasi[key].politeknik_swasta;
          // politeknik_kedinasan[i] =
          //   res.data.result.data[key].politeknik_kedinasan;
          akademi_negeri[i] = res.data.result.data_vokasi[key].akademi_negeri;
          akademi_swasta[i] = res.data.result.data_vokasi[key].akademi_swasta;
          // akademi_kedinasan[i] = res.data.result.data[key].akademi_kedinasan;
          ak_negeri[i] = res.data.result.data_vokasi[key].ak_negeri;
          ak_swasta[i] = res.data.result.data_vokasi[key].ak_swasta;
          // ak_kedinasan[i] = res.data.result.data[key].ak_kedinasan;
          i = i + 1;
        }

        this.setState({
          label: labels,
          politeknik_negeri: politeknik_negeri,
          politeknik_swasta: politeknik_swasta,
          // politeknik_kedinasan: politeknik_kedinasan,
          akademi_negeri: akademi_negeri,
          akademi_swasta: akademi_swasta,
          // akademi_kedinasan: akademi_kedinasan,
          ak_negeri: ak_negeri,
          ak_swasta: ak_swasta,
          // ak_kedinasan: ak_kedinasan,
          loading: false,
        });
      })
      .catch((err) => {
        alert("not found");
      });
  }
  async componentDidMount() {
    this.getData();
  }
  async componentDidUpdate() {
    if (this.props.status === true) {
      this.getData();
      this.props.parentCallback(false);
    }
  }
  render() {
    let datas = {
      labels: this.state.label,
      datasets: [
        {
          label: "Politeknik Negeri",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#4472C4",
          borderColor: "#4472C4",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#4472C4",
          pointBackgroundColor: "#4472C4",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#4472C4",
          pointHoverBorderColor: "#4472C4",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.politeknik_negeri,
        },
        {
          label: "Politeknik Swasta",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#5B9BD5",
          borderColor: "#5B9BD5",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#5B9BD5",
          pointBackgroundColor: "#5B9BD5",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#5B9BD5",
          pointHoverBorderColor: "#5B9BD5",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.politeknik_swasta,
        },
        // {
        //   label: "Politeknik Kedinasan",
        //   fill: false,
        //   lineTension: 0.1,
        //   backgroundColor: "#BCD8FF",
        //   borderColor: "#BCD8FF",
        //   borderCapStyle: "butt",
        //   borderDash: [],
        //   borderDashOffset: 0.0,
        //   borderJoinStyle: "miter",
        //   pointBorderColor: "#BCD8FF",
        //   pointBackgroundColor: "#BCD8FF",
        //   pointBorderWidth: 1,
        //   pointHoverRadius: 5,
        //   pointHoverBackgroundColor: "#BCD8FF",
        //   pointHoverBorderColor: "#BCD8FF",
        //   pointHoverBorderWidth: 2,
        //   pointRadius: 1,
        //   pointHitRadius: 10,
        //   data: this.state.politeknik_kedinasan,
        // },
        {
          label: "Akademi Negeri",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#E95E24",
          borderColor: "#E95E24",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#E95E24",
          pointBackgroundColor: "#E95E24",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#E95E24",
          pointHoverBorderColor: "#E95E24",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.akademi_negeri,
        },
        {
          label: "Akademi Swasta",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#F38254",
          borderColor: "#F38254",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#F38254",
          pointBackgroundColor: "#F38254",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#F38254",
          pointHoverBorderColor: "#F38254",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.akademi_swasta,
        },
        // {
        //   label: "Akademi Kedinasan",
        //   fill: false,
        //   lineTension: 0.1,
        //   backgroundColor: "#FFC3AB",
        //   borderColor: "#FFC3AB",
        //   borderCapStyle: "butt",
        //   borderDash: [],
        //   borderDashOffset: 0.0,
        //   borderJoinStyle: "miter",
        //   pointBorderColor: "#FFC3AB",
        //   pointBackgroundColor: "#FFC3AB",
        //   pointBorderWidth: 1,
        //   pointHoverRadius: 5,
        //   pointHoverBackgroundColor: "#FFC3AB",
        //   pointHoverBorderColor: "#FFC3AB",
        //   pointHoverBorderWidth: 2,
        //   pointRadius: 1,
        //   pointHitRadius: 10,
        //   data: this.state.akademi_kedinasan,
        // },
        {
          label: "AK Negeri",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#FFD900",
          borderColor: "#FFD900",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#FFD900",
          pointBackgroundColor: "#FFD900",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#FFD900",
          pointHoverBorderColor: "#FFD900",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.ak_negeri,
        },
        {
          label: "AK Swasta",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#FFEB77",
          borderColor: "#FFEB77",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#FFEB77",
          pointBackgroundColor: "#FFEB77",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#FFEB77",
          pointHoverBorderColor: "#FFEB77",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.ak_swasta,
        },
        // {
        //   label: "AK Kedinasan",
        //   fill: false,
        //   lineTension: 0.1,
        //   backgroundColor: "#FFF7C7",
        //   borderColor: "#FFF7C7",
        //   borderCapStyle: "butt",
        //   borderDash: [],
        //   borderDashOffset: 0.0,
        //   borderJoinStyle: "miter",
        //   pointBorderColor: "#FFF7C7",
        //   pointBackgroundColor: "#FFF7C7",
        //   pointBorderWidth: 1,
        //   pointHoverRadius: 5,
        //   pointHoverBackgroundColor: "#FFF7C7",
        //   pointHoverBorderColor: "#FFF7C7",
        //   pointHoverBorderWidth: 2,
        //   pointRadius: 1,
        //   pointHitRadius: 10,
        //   data: this.state.ak_kedinasan,
        // },
      ],
    };
    return (
      <>
        {this.state.loading === true ? (
          <span className="ml-3 spinner spinner-black"></span>
        ) : (
          <Bar data={datas} options={this.options} />
        )}
      </>
    );
  }
}
export default ChartSebaranPTVBerdasarkanKategori;
